// Simple OCR parsing utilities to extract key:value lines into an object

export const normalizeKey = (k) =>
  (k || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const parseKeyValueText = (text) => {
  if (!text || typeof text !== "string") return {};
  const lines = text
    .replace(/\r/g, "\n")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  const map = {};
  for (const line of lines) {
    // find first colon
    const idx = line.indexOf(":");
    if (idx === -1) continue;
    const rawKey = line.slice(0, idx).trim();
    const val = line.slice(idx + 1).trim();
    const key = normalizeKey(rawKey);
    if (key && val && map[key] == null) {
      map[key] = val;
    }
  }
  return map;
};

export const firstFrom = (kv, candidates) => {
  if (!kv) return "";
  for (const c of candidates) {
    const k = normalizeKey(c);
    if (kv[k]) return kv[k];
  }
  return "";
};

export const pickDate = (s) => {
  if (!s) return "";
  const str = s.toString().trim();
  // Try to normalize to YYYY-MM-DD when possible
  const dmy = str.match(/(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})/);
  if (dmy) {
    let [_, d, m, y] = dmy;
    if (y.length === 2) y = `20${y}`;
    const dd = d.padStart(2, "0");
    const mm = m.padStart(2, "0");
    return `${y}-${mm}-${dd}`;
  }
  const ymd = str.match(/(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})/);
  if (ymd) {
    const [_, y, m, d] = ymd;
    const dd = d.padStart(2, "0");
    const mm = m.padStart(2, "0");
    return `${y}-${mm}-${dd}`;
  }
  return str; // fallback as-is
};
